// extracted by mini-css-extract-plugin
export default {"productGallery":"nN-z","inQuickShop":"oN-z"};